import { ErrorContainer } from '../CreativeMediaError/ErrorContainer';
import { StyledMediaContainerDiv } from '../CreativeMediaError/Preview.styled';
import { useImaAd } from './useImaAd';

type VideoPlayerProps = {
  adMarkup: string;
  onClose: () => void;
  width: number;
  height: number;
};

export function VideoPlayer({ adMarkup, onClose, width, height }: VideoPlayerProps) {
  const { adContainerRef, isError } = useImaAd(adMarkup, {
    initDimensions: [width, height],
    onAdsManagerReady: (manager, ima) => {
      manager.setVolume(1);
      manager.addEventListener(ima.AdEvent.Type.CLICK, () => manager.resume());
      manager.addEventListener(ima.AdEvent.Type.COMPLETE, () => onClose());
    },
  });

  if (isError) {
    return <ErrorContainer height={height} width={width} />;
  }

  return <StyledMediaContainerDiv ref={adContainerRef} data-test="video-preview" width={width} height={height} />;
}
